import gql from 'graphql-tag';

const getResourceRolesQuery = gql`
  query ($organisationId: String!) {
    getRoles(roleType: RESOURCE, organisationId: $organisationId) {
      roleId
      name
    }
  }
`;

const getResourceRoles = () => ({
  query: getResourceRolesQuery,
  module: 'users',
  ignoreCache: true,
  buildVariables: (organisationId) => ({ organisationId })
});

export default getResourceRoles;